export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple
  },
  {
    title:  that.$l('choose_user_tb_username') || '姓名',
    field: 'userName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    field: 'userPost',
    minWidth: 100,
    align: 'left',
    title:  that.$l('choose_user_tb_userJob') || '职务角色',
    showHeaderOverflow: true
  },
  {
    title:  that.$l('choose_user_tb_mobileNumber') || '手机号',
    field: 'mobileNumber',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  },
  {
    field: 'orgName',
    minWidth: 170,
    align: 'left',
    title:  that.$l('choose_user_tb_orgName') || '所属公司',
    showHeaderOverflow: true
  },
  {
    title:  that.$l('choose_user_tb_depName') || '所属部门',
    field: 'depName',
    align: 'center',
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true
  }
]
